import type { DetailFieldListProps } from "./types-detail-field-list";
import { DetailFieldListView } from "./view-detail-field-list";

export function DetailFieldList(props: DetailFieldListProps) {
  return <DetailFieldListView {...props} />;
}

export type * from "./types-detail-field-list";
